const GAReducer = (state, action) => {
    switch (action.type) {
        case 'SET_PAGE_LOAD':
            return {
                ...state,
                pageLoad: action.payload
            }
        case 'SET_ENTER_SUBSTEP':
            return {
                ...state,
                enterSubstep: action.payload
            }
        case 'SET_EXIT_SUBSTEP':
            return {
                ...state,
                existSubstep: action.payload
            }
        case 'SET_EXIT_STEP':
            return {
                ...state,
                exitStep: action.payload
            }
        case 'SET_ENTER_REVIEW':
            return {
                ...state,
                enterReview: action.payload
            }
        case 'SET_CHECKOUT':
            return {
                ...state,
                checkout: action.payload
            }
        case 'SET_SAVE_DESIGN':
            return {
                ...state,
                saveDesign: action.payload
            }
        default:
            return state
    }
}

export default GAReducer